// Client-side photo processing for pledge submissions. Photos are stored
// inline (base64 data URL) on the pledge document, so they must be resized
// down before upload — the server rejects anything over 300k characters.

const MAX_DIMENSION = 320;
const JPEG_QUALITY = 0.72;
const MAX_FILE_BYTES = 8 * 1024 * 1024; // reject absurd source files early

export function fileToResizedDataUrl(file) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) {
      reject(new Error("Please choose an image file (JPG or PNG)."));
      return;
    }
    if (file.size > MAX_FILE_BYTES) {
      reject(new Error("Image is too large. Please choose a photo under 8 MB."));
      return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, MAX_DIMENSION / Math.max(img.width, img.height));
      const w = Math.max(1, Math.round(img.width * scale));
      const h = Math.max(1, Math.round(img.height * scale));
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL("image/jpeg", JPEG_QUALITY));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not read that image. Please try another photo."));
    };
    img.src = url;
  });
}
